import React from 'react';
import axios from 'axios';

import NavBaseTemplate from '../templates/NavBaseTemplate';
import Input from '../theme/forms/Input';
import DataTableWInputHeader from '../theme/tables/DataTableWInputHeader';
import FileDragAndDrop from '../theme/forms/FileDragAndDrop';

import {
  getS3SignedUrl,
  getDoorsFilePreview,
  postDoorDataAction,
} from '../../store/api/calls/doors';

import { pullCampaignOffices, pullCampaignScripts } from '../../store/api/calls';
import { connect } from 'react-redux';

const selectableFields = [
  {
    display: 'State Voter ID',
    value: 'state_voter_id',
  },
  {
    display: 'External ID',
    value: 'external_id',
  },
  {
    display: 'Last Name',
    value: 'last_name',
  },
  {
    display: 'First Name',
    value: 'first_name',
  },
  {
    display: 'Middle Name',
    value: 'middle_name',
  },
  {
    display: 'Suffix',
    value: 'suffix',
  },
  {
    display: 'Street Address 1',
    value: 'street_address_1',
  },
  {
    display: 'Street Address 2',
    value: 'street_address_2',
  },
  {
    display: 'City State Zip',
    value: 'city_state_zip',
  },
  {
    display: 'House Number',
    value: 'house_number',
  },
  {
    display: 'House Suffix',
    value: 'house_suffix',
  },
  {
    display: 'Street Predirection',
    value: 'street_predirection',
  },
  {
    display: 'Street Name',
    value: 'street_name',
  },
  {
    display: 'Street Type',
    value: 'street_type',
  },
  {
    display: 'Street Postdirection',
    value: 'street_postdirection',
  },
  {
    display: 'Unit Type',
    value: 'unit_type',
  },
  {
    display: 'Unit Number',
    value: 'unit_number',
  },
  {
    display: 'Non Standard Address',
    value: 'non_standard_address',
  },
  {
    display: 'City',
    value: 'city',
  },
  {
    display: 'State',
    value: 'state',
  },
  {
    display: 'zip5',
    value: 'zip5',
  },
  {
    display: 'zip4',
    value: 'zip4',
  },
  {
    display: 'County Name',
    value: 'county_name',
  },
  {
    display: 'Precinct Name',
    value: 'precinct_name',
  },
  {
    display: 'CD',
    value: 'CD',
  },
  {
    display: 'SD',
    value: 'SD',
  },
  {
    display: 'HD',
    value: 'HD',
  },
  {
    display: 'Latitude',
    value: 'latitude',
  },
  {
    display: 'Longitude',
    value: 'longitude',
  },
  {
    display: 'Geo Precision',
    value: 'geo_precision',
  },
  {
    display: 'Voter Status',
    value: 'voter_status',
  },
  {
    display: 'Household ID',
    value: 'household_id',
  },
  {
    display: 'Primary Phone',
    value: 'primary_phone',
  },
  {
    display: 'Primary Phone Type',
    value: 'primary_phone_type',
  },
  {
    display: 'Secondary Phone',
    value: 'secondary_phone',
  },
  {
    display: 'Secondary Phone Type',
    value: 'secondary_phone_type',
  },
  {
    display: 'Custom Field 1',
    value: 'custom1',
  },
  {
    display: 'Custom Field 2',
    value: 'custom2',
  },
  {
    display: 'Custom Field 3',
    value: 'custom3',
  },
  {
    display: 'Custom Field 4',
    value: 'custom4',
  },
  {
    display: 'Custom Field 5',
    value: 'custom5',
  },
  {
    display: 'Custom Field 6',
    value: 'custom6',
  },
  {
    display: 'Custom Field 7',
    value: 'custom7',
  },
  {
    display: 'Custom Field 8',
    value: 'custom8',
  },
  {
    display: 'Custom Field 9',
    value: 'custom9',
  },
  {
    display: 'Custom Field 10',
    value: 'custom10',
  },
];

class DoorsUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      loading: false,
      error: null,
      percentLoaded: 0,
      doorDataFile: null,
      doorCanvassName: '',
      doorCanvassPassName: '',
      scriptId: this.props.scripts[0]?.id || 0,
      officeId: this.props.offices[0]?.id || 0,
    };
  }

  componentDidMount() {
    this.handleMountOrCampaignUpdate();
  }

  componentDidUpdate(prevProps) {
    if (this.props.focusedCampaignId !== prevProps.focusedCampaignId) {
      this.handleMountOrCampaignUpdate();
    }
  }

  handleMountOrCampaignUpdate = () => {
    pullCampaignOffices().then(() => pullCampaignScripts());
  };

  handleInputChange = (val, name) => {
    this.setState({
      [name]: val,
    });
  };

  handleFileUpload = (file) => {
    this.setState({ percentLoaded: 0, file, fileName: file.name });
    let key;
    getS3SignedUrl(file.name)
      .then((res) => {
        const formData = new FormData();
        let fields = res.data.fields;
        key = res.data.key;

        this.setState({
          key,
        });

        Object.keys(fields).forEach((field) => {
          formData.append(field, fields[field]);
        });

        // now we are ready to append the file, but we have to rename it to match the key the server sent back
        const renamedFile = new File([file], key);
        formData.append('file', renamedFile);

        return axios.post(res.data.url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            this.setState({
              loadingMsg: Math.round((progressEvent.loaded / this.state.file.size) * 100) + '%',
            });
          },
        });
      })
      .then((response) => {
        console.log(response);
        this.setState({ loadingMsg: 'Getting file preview....' });

        return new Promise((resolve) => {
          setTimeout(() => {
            getDoorsFilePreview(key).then((res) => resolve(res));
          }, 1000);
        });
      })
      .then((res) => {
        this.setState({ uploadSuccess: true, loadingMsg: false });
        return res.data;
      })
      .then((data) => {
        // this id is being added so we can successfully key the table rows
        let keyedData = data.preview_lines.map((row) => {
          return { ...row, woxId: crypto.randomUUID() };
        });
        this.setState({ data: keyedData, encoding: data.encoding, loading: false });
      })
      .catch((error) => {
        this.setState({
          error: 'Your file failed to upload, please try again.',
          loadingMsg: false,
          data: null,
          doorDataFile: null,
          fileName: null,
        });
        console.warn(error);
      });
  };

  handleMapUpload = (fieldmap) => {
    const now = new Date();
    const date_string = `${now.getFullYear()}_${now.getMonth()}_${now.getDay()}`;
    const uniqueTableName =
      `${date_string}_${this.state.doorCanvassName}_S${this.state.scriptId}_C${this.props.focusedCampaignId}_O${this.state.officeId}`.replace(
        /\s/g,
        ''
      );

    let data_to_dispatch = {
      type: 'LOAD_FILE',
      file_name: this.state.key,
      target_table: uniqueTableName,
      canvass_config: {
        campaign_id: this.props.session.focusedCampaign.id,
        canvass_name: this.state.doorCanvassName,
        canvasspass_name: this.state.doorCanvassPassName,
        office_id: this.state.officeId,
        script_id: this.state.scriptId,
        cut_config: {},
      },
      fieldmap,
    };

    postDoorDataAction(data_to_dispatch)
      .then(() => this.setState({ upload_success: true }))
      .catch(() => this.setState({ error: 'There was an error processing that file.' }));
  };

  handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.handleFileUpload(this.state.doorDataFile);
  };

  handleFileChange = (file) => {
    this.setState({ doorDataFile: file });
  };

  render() {
    return (
      <NavBaseTemplate location={this.props.location} showAdmin={this.props.is_admin}>
        <h3>Doors Upload</h3>
        {this.state.upload_success && (
          <div>
            <h4 className={'primary-text'}>We've started your upload!</h4>
            <p>You will receive an email with the status as it completes.</p>
          </div>
        )}
        {!this.state.data && (
          <form onSubmit={this.handleSubmit}>
            <FileDragAndDrop
              file={this.state.doorDataFile}
              onChange={this.handleFileChange}
              formats={['tsv', 'csv']}
              promptText="Drop doors data (CSV or TSV) here"
            />
            {this.state.error && <p className="danger-text">{this.state.error}</p>}
            {this.state.doorDataFile && (
              <>
                <div className="flx wrap">
                  <Input
                    type="text"
                    classNames="mr-3"
                    title="Door Canvass Name"
                    onChange={(e) => this.handleInputChange(e, 'doorCanvassName')}
                    required
                  />
                  <Input
                    type="text"
                    classNames="mr-3"
                    title="Door Canvass Pass Name"
                    onChange={(e) => this.handleInputChange(e, 'doorCanvassPassName')}
                    required
                  />
                  <Input
                    type="select"
                    options={this.props.scripts.map((script) => ({
                      display: script.name,
                      value: script.id,
                    }))}
                    classNames="mr-3"
                    title="Script"
                    onChange={(e) => this.handleInputChange(e, 'scriptId')}
                    required
                  />
                  <Input
                    type="select"
                    classNames="mr-3"
                    title="Office"
                    options={this.props.offices.map((office) => ({
                      display: office.name,
                      value: office.id,
                    }))}
                    onChange={(e) => this.handleInputChange(e, 'officeId')}
                    required
                  />
                </div>
                <button
                  disabled={!!this.state.loadingMsg}
                  type="submit"
                  className="btn btn-primary"
                >
                  {this.state.loadingMsg || 'Upload'}
                </button>
              </>
            )}
          </form>
        )}

        {this.state.data && !this.state.upload_success && (
          <DataTableWInputHeader
            data={this.state.data}
            rowKey={'woxId'}
            selectableFields={selectableFields}
            handleUpload={this.handleMapUpload}
            requiredHeaders={[
              'state_voter_id',
              'first_name',
              'last_name',
              'street_address_1',
              ['street_address_2', ['unit_type', 'unit_number']],
              'city',
              'state',
              'zip5',
              'precinct_name',
            ]}
            title="Select Column Headers"
          />
        )}
      </NavBaseTemplate>
    );
  }
}

const mapStateToProps = (state) => ({
  focusedCampaignId: state.session.focusedCampaign.id,
  scripts: state.scripts.data,
  offices: state.offices.data,
  session: state.session,
});

export default connect(mapStateToProps)(DoorsUpload);
